export default "__VITE_ASSET__BrWXawEk__"